const cache = new Map<string, Promise<unknown>>();

export function loadJson<T>(relativePath: string): Promise<T> {
  const url = `${import.meta.env.BASE_URL}data/${relativePath}`;
  if (!cache.has(url)) {
    cache.set(url, fetch(url).then(async response => {
      if (!response.ok) throw new Response(`Could not load ${relativePath}`, {status: response.status});
      return response.json() as Promise<T>;
    }));
  }
  return cache.get(url) as Promise<T>;
}

export const pct = (value: number) => `${(value * 100).toFixed(1)}%`;
export const title = (value: string) => value.replaceAll('_', ' ').replace(/\b\w/g, char => char.toUpperCase());

export function capabilityBand(score: number) {
  if (score === 0) return 'Absent';
  if (score <= 2) return 'Incidental';
  if (score <= 4) return 'Useful secondary';
  if (score <= 6) return 'Reliable';
  if (score <= 8) return 'Core signature';
  return 'Exceptional';
}

export const capabilitySlug = (id: string) => id.replaceAll('_', '-');
export const capabilityId = (slug: string) => slug.replaceAll('-', '_');
